import { NetworkstatsState } from './networkstats.state'
import { UserNetworkStats } from '@/types/networkstats'

export const getters = {
  userStats: (state: NetworkstatsState) => {
    // legacy code expected download to be undefined
    // that's why at this point we don't simply use new UserNetworkStats()
    const emptyStats =  {
      download: undefined,
      upload: undefined,
      encoder: undefined,
      team_id: ''
    }

    return (userId: string): UserNetworkStats | undefined => state.userStats[userId] || emptyStats
  }
}
